import React from 'react';
import { TrendsFilterProvider } from '../../contexts/Trends/TrendsFilterContext';
import AggregatedProvider from '../../contexts/Emissions/AggregatedEmissionsContext';
import { ProvidersFilterContextProvider } from '../../contexts/FilterContexts/ProvidersFilterContext';
import { AccountsFilterContextProvider } from '../../contexts/FilterContexts/AccountsFilterContext';
import { ServicesFilterContextProvider } from '../../contexts/FilterContexts/ServicesFilterContext';
import { CategoriesFilterContextProvider } from '../../contexts/FilterContexts/CategoriesFilterContext';
import EmissionsContent from '../../components/organisms/EmissionsContent/EmissionsContent';
import TrendsData from './Components/TrendsData';
import TrendsFilter from './Components/TrendsFilter';

export const Trends = () => {
  return (
    <ProvidersFilterContextProvider>
      <AccountsFilterContextProvider>
        <ServicesFilterContextProvider>
          <CategoriesFilterContextProvider>
            <TrendsFilterProvider>
              <AggregatedProvider>
                <EmissionsContent>
                  <div className={'tds-container tds-u-mt2'}>
                    <div className={'tds-row'}>
                      <div className={'tds-col'}>
                        <TrendsFilter />
                        <TrendsData />
                      </div>
                    </div>
                  </div>
                </EmissionsContent>
              </AggregatedProvider>
            </TrendsFilterProvider>
          </CategoriesFilterContextProvider>
        </ServicesFilterContextProvider>
      </AccountsFilterContextProvider>
    </ProvidersFilterContextProvider>
  );
};
